import React, { useEffect, useState } from 'react';
import { Box, Button, Typography } from '@material-ui/core';
import LoadingScreen from 'src/components/LoadingScreen';

// ----------------------------------------------------------------------

// Seconds to wait before offering a manual reload. Long enough that a normal
// login (two sequential API calls) never sees it, short enough that a stuck
// session isn't a dead end.
const RELOAD_PROMPT_AFTER_MS = 15000;

// Shown while we know the user is authenticated but their profile/status has
// not arrived yet. Previously this in-between state rendered the signed-out
// route tree, so people saw the login page flash between the loading screen and
// the dashboard.
//
// If resolution takes unusually long (slow or failing API), a reload button
// appears under the logo after 15s so the user is never stranded on a spinner.
function AuthResolvingScreen() {
  const [showReload, setShowReload] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowReload(true), RELOAD_PROMPT_AFTER_MS);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Box
      sx={{
        height: '100%',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <LoadingScreen />

      {showReload && (
        <Box
          sx={{
            position: 'absolute',
            top: 'calc(50% + 110px)',
            left: 0,
            right: 0,
            zIndex: 10,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 1,
            px: 2
          }}
        >
          <Typography variant="body2" align="center" sx={{ color: 'text.secondary', mb: 1 }}>
            This is taking longer than usual.
          </Typography>
          <Button variant="contained" onClick={() => window.location.reload()}>
            Reload
          </Button>
        </Box>
      )}
    </Box>
  );
}

export default AuthResolvingScreen;
